const SELECTOR_MENU_CONTAINER = '.menu-container';
const SELECTOR_MENU_CLOSE = '.menu-close-button';
const SELECTOR_NAVIGATION_TOGGLE = '.menu-toggle-button';

const CLASS_MENU_CONTAINER_SHOW = 'menu-container-show';

class LinkeNavigation extends HTMLElement {
  constructor() {
    super();
    this.closeButton = null;
    this.navigationToggle = null;
    this.navigationContainer = null;
  }

  connectedCallback() {
    this.setElements();
    this.registerEvents();
  }

  setElements() {
    this.closeButton = this.querySelector(SELECTOR_MENU_CLOSE);
    this.navigationToggle = this.querySelector(SELECTOR_NAVIGATION_TOGGLE);
    this.navigationContainer = this.querySelector(SELECTOR_MENU_CONTAINER);
  }

  registerEvents() {
    this.closeButton.addEventListener('click', () => {
      this.navigationContainer.classList.remove(CLASS_MENU_CONTAINER_SHOW);
      document.body.classList.remove("dialog-open");
    });
    this.navigationToggle.addEventListener('click', () => {
      this.navigationContainer.classList.add(CLASS_MENU_CONTAINER_SHOW);
      document.body.classList.add("dialog-open");
    });
  }
}

if (!customElements.get("linke-navigation")) {
  customElements.define("linke-navigation", LinkeNavigation);
}
